// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1TtBw","calendarButtons":"ClockData_calendarButtons__2hOUa"};